/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@saucelabs/ds-modal';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import { ButtonText } from '@saucelabs/ds-button';
import { Typography } from '@saucelabs/ds-typography';
import { STANDARD_EVENTS, trackStandardEvent } from '@saucelabs/sl-util-segmentio';

import { NUDGE_ANNUAL_PLAN_MODAL, ROUTE_PARENT_SECTION, ROUTE_SECTION_CHECKOUT } from '../constants';
import { amountSeparator } from '../utils/numbers';
import { PRODUCT_AREA, PRODUCT_SUB_AREAS, SUBJECT } from '../tracking';

export interface AnnualNudgeModalProps {
  annualSavings: number;
  onContinue: () => void;
  updateToAnnual: () => void;
}

const AnnualNudgeModal: React.FC<AnnualNudgeModalProps> = ({
  annualSavings,
  onContinue,
  updateToAnnual,
}) => (
  <Modal
    data-qa="annual-nudge-modal"
    emphasis="critical"
    title="👋 Test for less money!"
  >
    <Typography
      disableSpacing
      variant="body-small"
    >
      Enjoy your subscription for
      {' '}
      {`${amountSeparator(annualSavings)}`}
      {' '}
      less per year. Switch to annual plan now.
    </Typography>
    <div className="flex justify-end pt-2 pb-0.5">
      <ButtonText
        elementType="button"
        onPress={() => {
          trackStandardEvent(
            STANDARD_EVENTS.OBJECT_CLICKED,
            PRODUCT_AREA,
            PRODUCT_SUB_AREAS.NUDGE_MODAL,
            SUBJECT.NUDGE_MODAL_CANCEL,
          );
          onContinue();
        }}
        to={`/${ROUTE_PARENT_SECTION}/${ROUTE_SECTION_CHECKOUT}`}
        variant="text"
      >
        No thanks, I&apos;m fine paying monthly
      </ButtonText>
      <ButtonText
        className="ml-2"
        color="primary"
        elementType="button"
        onPress={() => {
          trackStandardEvent(
            STANDARD_EVENTS.OBJECT_CLICKED,
            PRODUCT_AREA,
            PRODUCT_SUB_AREAS.NUDGE_MODAL,
            SUBJECT.NUDGE_MODAL_CONFIRM,
          );
          updateToAnnual();
          onContinue();
        }}
        to={`/${ROUTE_PARENT_SECTION}/${ROUTE_SECTION_CHECKOUT}`}
        variant="contained"
      >
        Switch to Annual Plan
      </ButtonText>
    </div>
  </Modal>
);

AnnualNudgeModal.propTypes = {
  onContinue: PropTypes.func.isRequired,
};

export default modalConnectV2(NUDGE_ANNUAL_PLAN_MODAL, AnnualNudgeModal);
export { AnnualNudgeModal };
